import * as React from "react";
import type { RouteComponentProps } from "react-router";
export default class NewVariableSet extends React.Component<RouteComponentProps> {
    render() {
        return <div>TODO</div>;
    }
    static displayName = "NewVariableSet";
}
